import {
  CourseAvailabilityCheckItemFactory,
  LearningTypeCheckItemFactory,
  ProductCheckItemFactory,
  RoleCheckItemFactory,
  TopicCheckItemFactory,
} from '@app/factories/_index';
import { FilterMatchTitle, FilterMatchType } from '@app/enums/_index';

import { Factory } from './_factory';
import { FilterCategoryItem } from '@app/models/_index';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

/**
 * Create Filter Category Item Factory used by the accordion component on the catalog filtering on search.
 * Creates instances of Filter Category Item
 */
@Injectable({
  providedIn: 'root',
})
export class FilterCategoryFactory implements Factory<FilterCategoryItem> {
  filterCategories: FilterCategoryItem[] = [];
  showCourseAvailabilityFacet = false;

  /**
   * Call and build static Filter Category Items array.
   * Do not add or remove items from this array.
   * Used as a read-only reference.
   */
  constructor(
    private learningTypeFactory: LearningTypeCheckItemFactory,
    private productFactory: ProductCheckItemFactory,
    private roleFactory: RoleCheckItemFactory,
    private topicFactory: TopicCheckItemFactory,
    private courseAvailabilityFactory: CourseAvailabilityCheckItemFactory
  ) {
    this.showCourseAvailabilityFacet = environment.beyond.featureFlags.showCourseAvailabilityFacet;
    this.build();
  }

  /**
   * Build static Filter Category Item array
   */
  build(): void {
    this.filterCategories.push(
      new FilterCategoryItem(
        FilterMatchType.GENESYS_PRODUCT,
        FilterMatchTitle.GENESYS_PRODUCT,
        '',
        this.productFactory.getCollection(),
        false,
        FilterMatchType.GENESYS_PRODUCT
      )
    );
    this.filterCategories.push(
      new FilterCategoryItem(
        FilterMatchType.INSTRUCTION_TYPE,
        FilterMatchTitle.INSTRUCTION_TYPE,
        '',
        this.learningTypeFactory.getCollection(),
        false,
        FilterMatchType.INSTRUCTION_TYPE
      )
    );
    this.filterCategories.push(
      new FilterCategoryItem(
        FilterMatchType.ROLE,
        FilterMatchTitle.ROLE,
        '',
        this.roleFactory.getCollection(),
        false,
        FilterMatchType.ROLE
      )
    );
    this.filterCategories.push(
      new FilterCategoryItem(
        FilterMatchType.TOPIC,
        FilterMatchTitle.TOPIC,
        '',
        this.topicFactory.getCollection(),
        false,
        FilterMatchType.TOPIC
      )
    );
    if (this.showCourseAvailabilityFacet) {
      this.filterCategories.push(
        new FilterCategoryItem(
          FilterMatchType.COURSE_AVAILABILITY,
          FilterMatchTitle.COURSE_AVAILABILITY,
          '',
          this.courseAvailabilityFactory.getCollection(),
          false,
          FilterMatchType.COURSE_AVAILABILITY
        )
      );
    }
  }

  /**
   * Return immutable or copy of Filter Category Items collection
   * @returns - a slice or copy of thes static collection
   */
  getCollection(): FilterCategoryItem[] {
    if (this.filterCategories && this.filterCategories.length === 0) {
      this.build();
    }
    return this.filterCategories.slice();
  }
}
